import { call, put, takeLatest } from 'redux-saga/effects';
import { USER_DATA_REQUEST } from '../constants';
import { userDataSuccess, userDataFailure } from '../actions/userdataAction';
import { adminAPI } from '../../utils/axiosInstance';

function* userDataSaga(action) {
  try {
    const { userId } = action.payload;
    if (!userId) {
      return;
    }
    const response = yield call([adminAPI,'get'], `/admin/user/${userId}`);
    yield put(userDataSuccess(response.data));
  } catch (error) {
    console.log("Error from profile saga", error);
    yield put(userDataFailure(error.response?.data?.message || 'Getting user failed, Try Again'));
  }
}

export default function* watchUserData() {
  yield takeLatest(USER_DATA_REQUEST, userDataSaga);
}